import React from "react";
import PropTypes from "prop-types";

import ChunkCard from "cards/containers/ChunkCard";

import aliasCropNames from "utils/aliasCropNames";

export default function CompatChunkCard({ chunk, ...props }) {
  // we rename these fields in the middleware bc numbers
  const imageCropChunk = aliasCropNames(chunk);

  return <ChunkCard {...props} chunk={imageCropChunk} />;
}

ChunkCard.propTypes = {
  chunk: PropTypes.shape({
    id: PropTypes.string.isRequired,
    headline: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    primary_image: PropTypes.object,
    blocks: PropTypes.object,
    is_expert_voices: PropTypes.bool,
  }).isRequired,
  index: PropTypes.number.isRequired,
};
